require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./truncatedtext"), require("./flexlayout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./truncatedtext", "./flexlayout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./truncatedtext"), require("./flexlayout")) : factory(root["./utils"], root["./truncatedtext"], root["./flexlayout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[67],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__14__;

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-toggleSwitch .bx--toggle__switch{margin-top:0}", ""]);

// exports
exports.locals = {
	"toggleSwitchClassName": "\"ba-toggleSwitch\""
};

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(559);


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ToggleSwitch = _interopRequireDefault(__webpack_require__(560));

exports.default = _ToggleSwitch.default;
exports.ToggleSwitch = _ToggleSwitch.default;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _flexlayout = _interopRequireDefault(__webpack_require__(14));

var _lodash = __webpack_require__(18);

var _utils = __webpack_require__(5);

var _truncatedtext = _interopRequireDefault(__webpack_require__(13));

var _baUiCarbon = __webpack_require__(9);

var _ToggleSwitch = _interopRequireDefault(__webpack_require__(561));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const toggleSwitchClassName = _ToggleSwitch.default.toggleSwitchClassName.replace(/"/g, '');

const {
  BaPropTypes
} = _utils.propsUtils;

class ToggleSwitch extends _react.Component {
  render() {
    var _ref;

    const {
      // remove - remapped

      /* eslint-disable react/prop-types */
      className,
      disabled,
      id,
      labelA,
      labelB,
      onChange,
      onToggle,
      small,
      tabIndex,
      toggled,

      /* eslint-enable react/prop-types */
      // remove - deprecated
      active,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      align,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      checkboxInputExtraOptions,
      checked,
      hover,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      indeterminate,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      label,
      readOnly,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // pass all other props to CarbonToggle
      ...otherToggleProps
    } = this.props;
    const {
      displayLabel
    } = this.props; // eslint-disable-line react/prop-types

    const mappedId = id != null ? id : (0, _lodash.uniqueId)('__toggleSwitch_'); // labelA/labelB are suppose to accept nodes but they only accept strings.
    // Carbon bug: https://github.com/carbon-design-system/carbon/pull/6811

    const mappedLabelA = labelA != null ? labelA : '';
    /* this is against Carbon but needed for now */

    const mappedLabelB = labelB != null ? labelB : '';
    /* this is against Carbon but needed for now */

    const mappedOnChange = onToggle ? onChange : undefined;
    const mappedOnToggle = onToggle != null ? onToggle : onChange;
    const mappedTabIndex = tabIndex != null ? tabIndex : 0;
    const mappedToggled = (_ref = toggled != null ? toggled : checked) != null ? _ref : false;
    const hasCarbonLabelProps = !!(labelA || labelB || displayLabel);
    let mappedClassNameForFlex;
    let mappedClassNameForToggle = className;

    if (!hasCarbonLabelProps) {
      const classNames = (0, _utils.classnames)(toggleSwitchClassName);
      mappedClassNameForFlex = `${classNames} ${className != null ? className : ''}`;
      mappedClassNameForToggle = undefined;
    }

    const Toggle = small ? _baUiCarbon.ToggleSmall : _baUiCarbon.Toggle;

    const carbonToggleWidget = /*#__PURE__*/_react.default.createElement(Toggle, (0, _extends2.default)({}, otherToggleProps, checkboxInputExtraOptions != null ? checkboxInputExtraOptions : {}, {
      className: mappedClassNameForToggle,
      disabled: disabled,
      id: mappedId,
      labelA: mappedLabelA,
      labelB: mappedLabelB,
      onChange: mappedOnChange,
      onToggle: mappedOnToggle,
      tabIndex: mappedTabIndex,
      toggled: mappedToggled
    }));

    if (hasCarbonLabelProps) {
      return carbonToggleWidget;
    } // Label hack (for pre 11.2.0 compatibility)
    // Basically: use deprecated 'label' prop (if applicable), remove top margin (see ToggleSwitch.scss)


    const mappedLabel = typeof label === 'string' ? /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
      disabled: disabled,
      value: label
    }) : label;
    return /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      alignItems: "center",
      inline: true,
      className: mappedClassNameForFlex
    }, carbonToggleWidget, mappedLabel && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: mappedId,
      style: {
        marginLeft: '8px'
      }
    }, mappedLabel));
  }

}

exports.default = ToggleSwitch;
(0, _defineProperty2.default)(ToggleSwitch, "propTypes", {
  // focusable in sequential keyboard navigation */
  tabIndex: _propTypes.default.number,

  /** Which Carbon toggle to use: true = ToggleSmall, false = Toggle */
  small: _propTypes.default.bool,

  /** deprecated - no Carbon option */
  active: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  align: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - just pass in the props */
  checkboxInputExtraOptions: BaPropTypes.deprecated('deprecated - just pass in the props'),

  /** deprecated - use Carbon prop toggled */
  checked: BaPropTypes.deprecated('deprecated - use Carbon prop toggled'),

  /** deprecated - no Carbon option */
  hover: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  indeterminate: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - use Carbon prop labelText */
  label: BaPropTypes.deprecated('deprecated - use Carbon prop labelText'),

  /** deprecated(sort of) - used as Toolkit prop returns a non-standard signature(bool), used as Carbon prop returns standard signature(event). Better to use onToggle signature(bool, id, event).' */
  onChange: BaPropTypes.deprecated('deprecated(sort of) - used as Toolkit prop returns a non-standard signature(bool), used as Carbon prop returns standard signature(event). Better to use onToggle signature(bool, id, event).'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)')
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ToggleSwitch_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ToggleSwitch_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ToggleSwitch_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ToggleSwitch_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ToggleSwitch_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[558,0]]]);
});